import {btn, comp, Store, store, tbar, Window} from "@intermesh/goui";
import {MessageUserEntity} from "./data/MessagesStore.js";
import {ServiceMessages} from "./components/ServiceMessages.js";
import {t} from "./util/Translate.js";

export class UserMessageListDialog extends Window {
	private store: Store | undefined;

	constructor() {
		super();
		this.store = store();

		this.modal = true;
		this.width = 600;
		this.maximizable = false;
		this.draggable = false;
		this.resizable = false;

		this.title = t("Service messages");

		const sm = new ServiceMessages;

		this.on("show", () => {
			let itemCards = [];
			for (let item of this.store!.items) {
				let titleCls = "ifw-title";
				if (item.seen) {
					titleCls += " read";
				}
				const card = comp({cls: "ifw-card"},
					comp({cls: "vbox pad"},
						comp({tagName: "h2", cls: titleCls, text: item.message.title}),
						comp({tagName: "p", html: item.message.description}),
					),
					tbar({hidden: item.seen}, "->",
						btn({
							text: t("Stop showing"), handler: () => {
								sm.markRead(item.id, true).then(() => {
									this.close();
								})
							}
						}),
						btn({
							text: t("Mark as read"), handler: () => {
								sm.markRead(item.id, false).then(() => {
									this.close();
								})
							}
						})
					));

				itemCards.push(card);
			}

			this.items.add(...itemCards);

		});

	}

	public loadData(items: MessageUserEntity[]) {
		this.store!.loadData(items, false);
	}

}